module.exports = __webpack_public_path__ + "static/media/basil_invoice-solid.4c97718b.svg";